export default __webpack_public_path__ + "static/media/hero_landing_image_desktop.9e006573.png";